import React, { useMemo } from "react";
import QuickFiltersBar from "../../components/Organismos/Table/QuickFiltersBar";
import { useStaffMode } from "../../hooks/StaffModeProvider";
import type { AccountingOfficeGroupTab } from "../../utils/accountingOfficeDetail";

interface AccountingOfficeGroupTabsProps {
  tabs: AccountingOfficeGroupTab[];
  activeOfficeId: string;
  onSelect: (officeId: string) => void;
}

export default function AccountingOfficeGroupTabs({
  tabs,
  activeOfficeId,
  onSelect,
}: AccountingOfficeGroupTabsProps): React.ReactElement | null {
  const { isStaffMode } = useStaffMode();
  const quickFilters = useMemo(
    () => tabs.map(({ id, label }) => ({ key: id, label })),
    [tabs],
  );

  if (tabs.length === 0) {
    return null;
  }

  const barBackground = isStaffMode ? "bg-accent-Default-dark" : "bg-gray-15";

  return (
    <div className={`overflow-hidden rounded-t-lg ${barBackground}`}>
      <QuickFiltersBar
        quickFilters={quickFilters}
        selectedQuickFilter={activeOfficeId}
        quickFilterTotalCount={{}}
        onQuickFilterClick={onSelect}
        showCounts={false}
        lockActiveQuickFilter
        roundedTop={false}
      />
    </div>
  );
}
